import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getSchoolLogoForLogin } from "../../actions/SchoolActions";
import { fetchInterviewLinks } from "../../actions/StudentActions";
import { awaitableRootSchoolCode } from "../../apis/ApiConfig";
import UserSideBar from "./UserSideBar";

const UserSideBarWrapper = ({ global, student, school, isSignedIn, getSchoolLogoForLogin, fetchInterviewLinks, content, accountType, interviewLinks}) => {
  const [incompleteInterviewCount, setIncompleteInterviewCount] = useState(0);
  useEffect(() => {
    async function fetchData() {
      var schoolCode;
      if (!isSignedIn) {
        schoolCode = await awaitableRootSchoolCode();
      } else {
        schoolCode = school.schoolCode;
      }

      getSchoolLogoForLogin(
        schoolCode
      );
    }
    fetchData();
  }, [school.schoolCode, getSchoolLogoForLogin, isSignedIn]);


  useEffect(() => {
     async function fetchData() {
      if (student?.id && !interviewLinks) {
        fetchInterviewLinks(student.id, global?.aidYear);
      }
    }

    let currentTaskList = interviewLinks?.filter(
      (x) => x.isForParentAccount === (accountType === "parent")
    );

    fetchData();

    if (currentTaskList) {
      const incompleteInterviews = currentTaskList.filter((x) => x.studentInterviewLinkStatus === "NEW");
      setIncompleteInterviewCount(incompleteInterviews.length);
    } else {
      setIncompleteInterviewCount(0);
    }
  }, [global.aidYear, student?.id, interviewLinks, fetchInterviewLinks, accountType]);

  return (
    <div>
      {isSignedIn && (
        <>
          <UserSideBar logo={<img
            src={`data:image/jpeg;base64,${school.schoolLogo}`}
            alt={school.schoolName + "_logo"}
          ></img>}
            content={content}
            interviewCount={incompleteInterviewCount}
           >
          </UserSideBar>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    accountType: state.auth.user.accountType,
    global: state.global,
    student: state.student.student,
    interviewLinks: state.student.interviewLinks,
    school: state.school,
    isSignedIn: state.auth.isSignedIn
  };
};

export default connect(mapStateToProps, { getSchoolLogoForLogin, fetchInterviewLinks })(
  UserSideBarWrapper
);
